import { render, staticRenderFns } from "./SaveChangeMonyeForm.vue?vue&type=template&id=d4a735c4&scoped=true&"
import script from "./SaveChangeMonyeForm.vue?vue&type=script&lang=js&"
export * from "./SaveChangeMonyeForm.vue?vue&type=script&lang=js&"
import style0 from "./SaveChangeMonyeForm.vue?vue&type=style&index=0&id=d4a735c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a735c4",
  null
  
)

export default component.exports